import { Zap, KeyRound, BatteryCharging, Fuel, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { waLink } from "../../lib/site";

const services = [
  {
    id: "eletrica-geral",
    name: "Elétrica em geral",
    tag: "Diagnóstico avançado",
    description:
      "Mapeamento completo de fiação, eliminação de fuga de corrente, iluminação, fusíveis, relés e módulos eletrônicos. O defeito que ninguém acha, nós encontramos.",
    icon: Zap,
    large: true,
  },
  {
    id: "motor-arranque",
    name: "Motor de arranque",
    tag: "Reparo e troca",
    description:
      "Carro não dá partida? Reparo ou substituição imediata de automático, escovas, bendix e induzido — no local.",
    icon: KeyRound,
  },
  {
    id: "alternador",
    name: "Alternador & carga",
    tag: "Teste de voltagem",
    description:
      "Regulador de voltagem, placa retificadora, correia e teste completo de carga de bateria 12V/24V.",
    icon: BatteryCharging,
  },
  {
    id: "bomba-combustivel",
    name: "Bomba de combustível",
    tag: "Pressão e vazão",
    description:
      "Diagnóstico de pressão de linha, troca de refil de bomba, relés de alimentação e chicotes de injeção eletrônica.",
    icon: Fuel,
  },
];

export default function Services() {
  return (
    <section id="servicos" data-testid="services-section" className="relative py-24 sm:py-32 bg-[#0b0d10]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
          <div>
            <p className="font-tech text-xs uppercase tracking-[0.25em] text-[#e8112d] font-semibold mb-4">
              Especialidades técnicas
            </p>
            <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-slate-100">
              O que resolvemos no local
            </h2>
          </div>
          <p className="text-sm text-slate-500 max-w-xs">
            Peças de reposição a bordo. Garantia escrita em cada serviço executado.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5">
          {services.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.1}>
              <a
                href={waLink(`Olá! Preciso de atendimento 24h para: ${s.name}. Podem vir até mim?`)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`service-card-${s.id}`}
                className={`card-metal metal-edge-top group relative rounded-2xl border border-white/5 hover:border-[#e8112d]/50 p-8 flex flex-col transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl hover:shadow-[#e8112d]/10 ${
                  s.large ? "md:row-span-2 justify-between min-h-[320px]" : ""
                }`}
              >
                <div>
                  <div className="flex items-start justify-between">
                    <span className="w-12 h-12 rounded-xl bg-[#e8112d]/10 border border-[#e8112d]/25 flex items-center justify-center">
                      <s.icon className="w-6 h-6 text-[#e8112d]" />
                    </span>
                    <ArrowUpRight className="w-5 h-5 text-slate-600 group-hover:text-[#e8112d] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" />
                  </div>
                  <p className="font-tech text-[11px] uppercase tracking-[0.22em] text-[#c7cbd4] mt-6">{s.tag}</p>
                  <h3 className="mt-3 text-xl sm:text-2xl font-semibold text-slate-100 tracking-tight">{s.name}</h3>
                </div>
                <p className="mt-4 text-sm sm:text-base text-slate-400 leading-relaxed">{s.description}</p>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
